module.exports = __webpack_public_path__ + "img/f05.b5477e4a.webp";